import Vue from 'vue'
import Vuex from 'vuex'

import counterModule from './counter-module'
import accountModule from './account-module'
import treeModule from './tree-module'
import { alert } from './alert.module';
import { account } from './account.module';
import { users } from './users.module';

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        version: '1.0.0'
    },
    modules: {
        counterModule: counterModule,
        accountModule: accountModule,
        treeModule: treeModule,
        alert,
        account,
        users
    }
})
